// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-element-icon {
  height: 28px;
  width: 16px;
  position: relative;
  object-fit: contain;
  background-color: transparent !important;
  border: none !important;
  color: #fff !important;
}

.date {
  align-self: stretch;
  height: 17px;
  position: relative;
  font-weight: 500;
  display: inline-block;
  font-size: 22px;
}

.date-container {
  width: 199px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5.5px 0 0;
  box-sizing: border-box;
}

.navigation-element-icon1 {
  height: 28px;
  width: 16px;
  position: relative;
  object-fit: contain;
  background-color: transparent !important;
  border: none !important;
  color: #fff !important;
  transform: rotate(180deg);
}

.game-date-navigation-bar {
  height: 60px;
  background-color: #002129;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 40px;
  box-sizing: border-box;
  line-height: normal;
  letter-spacing: normal;
  gap: 20px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  font-family: var(--font-inter);
  margin: 0 auto;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/superPickemStyles/DateNavBar.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,uBAAA;EACA,sBAAA;AACJ;;AACE;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAEJ;;AAAE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;AAGJ;;AADE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAIJ;;AAFE;EAEE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;AAIJ","sourcesContent":[".navigation-element-icon {\n    height: 28px;\n    width: 16px;\n    position: relative;\n    object-fit: contain;\n    background-color: transparent  !important;\n    border: none !important;\n    color:#fff !important;\n  }\n  .date {\n    align-self: stretch;\n    height: 17px;\n    position: relative;\n    font-weight: 500;\n    display: inline-block;\n    font-size:22px;\n  }\n  .date-container {\n    width: 199px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding: 5.5px 0 0;\n    box-sizing: border-box;\n  }\n  .navigation-element-icon1 {\n    height: 28px;\n    width: 16px;\n    position: relative;\n    object-fit: contain;\n    background-color: transparent  !important;\n    border: none !important;\n    color:#fff !important;\n    transform: rotate(180deg);\n  }\n  .game-date-navigation-bar {\n    // width: 375px;\n    height: 60px;\n    background-color: #002129;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 16px 40px;\n    box-sizing: border-box;\n    line-height: normal;\n    letter-spacing: normal;\n    gap: 20px;\n    text-align: center;\n    font-size: 24px;\n    color: #fff;\n    font-family: var(--font-inter);\n    margin: 0 auto;\n    width:100%;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
